export const TERMS_MODAL_OPEN = "TERMS_MODAL_OPEN";
export const TERMS_MODAL_CLOSE = "TERMS_MODAL_CLOSE";